import React from 'react'
import {
    Route,
    Redirect,
    withRouter
} from "react-router-dom"

const AuthRoute = ({ component: Component, ...rest }) => {

    const user = JSON.parse(sessionStorage.getItem('user'))

    if(!user){
        return <Redirect to={`/login?redirect=${rest.location.pathname}`}/>
    }

    const isAuthenticated = user && user.token

    let hasPermissions = true
    if(isAuthenticated){
        const userPermissions = user.user.simple_permissions || []

        if(rest.hasOwnProperty('permissions')){
            hasPermissions = rest.permissions.every(permission_id => userPermissions.includes(permission_id))
        }
    }


    return (
        <Route
            {...rest}
            render={props =>
                isAuthenticated && hasPermissions ? (
                    <Component {...props} user_id={user.user.user_id} user={user.user}/>
                ) : (
                    <Redirect
                        to="/permission_denied"
                    />
                )
            }
        />
    );
}

export default withRouter(AuthRoute)